import React from 'react';

export const errorPagesConfigs = [
  {
    auth: null,
    routes: [
      {
        path: '/error-pages/error-404',
        component: React.lazy(() => import('./Error404')),
      },
    ],
  },
  {
    auth: null,
    routes: [
      {
        path: '/error-pages/error-500',
        component: React.lazy(() => import('./Error500')),
      },
    ],
  },
  {
    auth: null,
    routes: [
      {
        path: '/error-pages/maintenance',
        component: React.lazy(() => import('./Maintenance')),
      },
    ],
  },
];
